import React from 'react'
import PropTypes from 'prop-types'
import _ from "lodash"

class Countdown extends React.PureComponent {
  constructor (props) {
    super(props)

    const nowMillis = Date.now()
    let end
    if (props.end) {
      end = props.end
    } else if (props.secondsLeft && props.secondsLeft > 0) {
      end = nowMillis + (props.secondsLeft * 1000)
    } else {
      end = nowMillis
    }

    this.state = {
      countdown: this.countdownLeft(new Date(nowMillis), new Date(end)),
      end: end,
      intervalId: undefined,
      initialTimeoutId: undefined
    }
  }

  componentDidMount () {
    const leftMilliSeconds = this.countdownLeft(new Date(Date.now()), new Date(this.state.end)).seconds * 1000

    this.state.initialTimeoutId = setTimeout(() => {
      this.updateCountdown()
      this.state.intervalId = setInterval(() => this.updateCountdown(), 1000 * 60)
    }, leftMilliSeconds)
  }

  componentWillUnmount () {
    clearTimeout(this.state.initialTimeoutId)
    clearInterval(this.state.intervalId)
  }

  updateCountdown () {
    this.setState({
      countdown: this.countdownLeft(new Date(Date.now()), new Date(this.state.end))
    })
  }

  countdownLeft (dateStart, dateEnd) {
    const dateDiff = dateEnd - dateStart

    const leftDays = dateDiff / 86400000
    const leftHours = (leftDays - Math.floor(leftDays)) * 24
    const leftMinutes = (leftHours - Math.floor(leftHours)) * 60
    const leftSeconds = (leftMinutes - Math.floor(leftMinutes)) * 60

    let days = 0
    let hours = 0
    let minutes = 0
    let seconds = 0

    if (dateStart < dateEnd) {
      days = Math.floor(leftDays)
      hours = Math.floor(leftHours)
      minutes = Math.floor(leftMinutes)
      seconds = Math.floor(leftSeconds)
    }

    return { days, hours, minutes, seconds }
  }

  numberToDigitStrings(num) {
    const paddedString = num.toString().padStart(2, "0")
    const digits = paddedString.split("")
    return digits
  }

  render () {
    const { days, hours, minutes } = this.state.countdown

    return (
      <div className='countdown'>
        <div className='countdown__inner'>
          <h3 className='countdown__title'>{this.props.title}</h3>
          <div className='countdown__content'>
            <div className='countdown__item'>
              <div className='countdown__digitGroup'>
                {_.map(this.numberToDigitStrings(days), (digit, index) => {
                  return <span key={index} className='countdown__digitGroup__digit' data-testid='day'>{digit}</span>
                })}
              </div>
              <span className='countdown__letter'>{days === 1 ? this.props.short_day : this.props.short_days}</span>
            </div>
            <div className='countdown__item'>
              <div className='countdown__digitGroup'>
                {_.map(this.numberToDigitStrings(hours), (digit, index) => {
                  return <span key={index} className='countdown__digitGroup__digit' data-testid='hour'>{digit}</span>
                })}
              </div>
              <span className='countdown__letter'>{this.props.short_hour}</span>
            </div>
            <div className='countdown__item'>
              <div className='countdown__digitGroup'>
                {_.map(this.numberToDigitStrings(minutes), (digit, index) => {
                  return <span key={index} className='countdown__digitGroup__digit' data-testid='minute'>{digit}</span>
                })}
              </div>
              <span className='countdown__letter'>{this.props.short_minutes}</span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Countdown.propTypes = {
  end: PropTypes.string,
  title: PropTypes.string,
  short_day: PropTypes.string,
  short_hour: PropTypes.string,
  short_minutes: PropTypes.string
}
export default Countdown
